import { render, staticRenderFns } from "./crudEmployee.vue?vue&type=template&id=5cfd074c&scoped=true&"
import script from "./crudEmployee.vue?vue&type=script&lang=js&"
export * from "./crudEmployee.vue?vue&type=script&lang=js&"
import style0 from "./crudEmployee.vue?vue&type=style&index=0&id=5cfd074c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd074c",
  null
  
)

export default component.exports